/* eslint-disable no-undef */
import { setDeniedOverrideClicked } from 'src/pages/orders/redux/actions';
import store from 'src/rootRedux/store';
import { getTimeZoneName } from 'src/utils/dateUtils';
import { checkProxyActive, getUrlparams, getWcmsHostName } from 'src/utils/util.js';

const isImpersonationSessionActive = () => {
    if (checkProxyActive()) {
        return true;
    } else if (sessionStorage.getItem('proxyTerminationFlag')) {
        return true;
    } else if (sessionStorage.getItem('impersonationEndFlag')) {
        return true;
    } else {
        const impersonatedFlag = sessionStorage.getItem('impersonationFlag');
        const impersonatedUrlFlag = getUrlparams().get('impersonatedFlag');

        return impersonatedFlag === 'true' && impersonatedUrlFlag;
    }
};

const getImpersonationLink = () => {
    if (checkProxyActive()) {
        const proxyUserId = sessionStorage.getItem('proxyUserId');

        return `proxyFlag=true&proxyUser=${proxyUserId}`;
    } else if (sessionStorage.getItem('proxyTerminationFlag')) {
        return 'terminateProxy=true';
    } else if (sessionStorage.getItem('impersonationEndFlag')) {
        return 'terminateImpersonation=true';
    } else {
        const impersonatedUserId = sessionStorage.getItem('impersonatedUserId');
        return `impersonatedFlag=true&impersonatedUser=${impersonatedUserId}`;
    }
};

export const sideNavLinksWCMSLinks = (linkName) => {
    let sideNavLink = '';
    store.store.dispatch(setDeniedOverrideClicked(false));
    switch (linkName) {
        case 'orders':
            sideNavLink = 'view/content/spineOrderHistoryView?clearonsrch=true';
            break;
        case 'alerts':
            sideNavLink =
                'view/content/spineNotificationsView?refineData=false';
            break;
        case 'inventory':
            sideNavLink = 'view/content/InventoryListpage';
            break;
        case 'announcements':
            sideNavLink = 'view/content/spineAnnouncementsView';
            break;
        case 'accounts':
            sideNavLink = 'view/content/spineAccountsView';
            break;
        case 'links':
            sideNavLink = 'view/content/spineWebLinksView';
            break;
        case 'physicians':
            sideNavLink = 'view/content/spinePhysiciansView';
            break;
        case 'proxies':
            sideNavLink = 'view/content/spineUserProxyView';
            break;
        case 'salesCharges':
            sideNavLink = 'view/content/spineSalesChargeView';
            break;
        case 'settings':
            sideNavLink = 'view/content/spineUserPreference';
            break;
        case 'productGuide':
            sideNavLink = 'view/content/standaloneCatalog';
            break;
        case 'templates':
            sideNavLink = 'view/content/spineTemplateView';
            break;
        case 'mycaseMobile':
            sideNavLink = 'view/content/mobileLandingView';
            break;
        case 'fieldInventoryDashboard':
            sideNavLink = 'view/content/InventoryDashBoardListPage?getDashBoardDistricts=true&currentTab=surgeryNeeds&refine=false&search=false';
            break;
    }
    const isParameter = sideNavLink.includes('?');
    const host = getWcmsHostName().replace(/\/+$/, '');

    return isImpersonationSessionActive()
        ? `${host}/${sideNavLink}${
              isParameter ? '&' : '?'
          }${getImpersonationLink()}`
        : `${host}/${sideNavLink}`;
};
export const scheduleSurgeryWCMSLink = () => isImpersonationSessionActive()
    ? `${getWcmsHostName()}/view/content/modifySurgeryDetails?newSurgeryOrder=true&${getImpersonationLink()}`
    : `${getWcmsHostName()}/view/content/modifySurgeryDetails?newSurgeryOrder=true`;

export const getAdminPageWCMSLink = () => `${getWcmsHostName()}/view/content/spineConsoleManageView`;

export const getCTAWCMSLink = (order, cta) => {
    let redirectionLink = '';
    let timeZoneOffset = new Date().getTimezoneOffset();
    let timeZoneAbbr = getTimeZoneName(new Date());
    switch (cta.ctaId) {
        case 'CTA_001': {
            //VIEW
            const consignemntReturn = ['ZKA', 'L2', 'KR', 'G2', 'ZRE']; //Consignment Return Order Type
            if (
                consignemntReturn.includes(order?.orderType) ||
                consignemntReturn.includes(order?.currentOrderType)
            ) {
                redirectionLink = `view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&sstRef=${order.myCaseRef}&popupRequired=billingsummary`;
            } else {
                redirectionLink = `view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&sstRef=${order.myCaseRef}`;
            }
            break;
        }
        case 'CTA_002': //DELETE
            redirectionLink = `view/SpineCartViewComponentController?deleteDraft=true&orderId=${order.cartId}`;
            break;
        case 'CTA_004': // CREATE TEMPLATE - handled in-app
        case 'CTA2':   // CREATE TEMPLATE (order summary API) - handled in-app
            break;
        case 'CTA_005': //EDITORDER
            if (order?.orderType === 'ZLC' || order?.currentOrderType === 'ZLC') {
                redirectionLink = `view/content/modifySurgeryDetails?modifySurgery=true&isDraftOrder=true&surgeryOrderId=${order.myCaseRef}`;
            } else if (
                order.orderType === 'ZOR' ||
                order.currentOrderType === 'ZOR'
            ) {
                redirectionLink = `view/content/spineAccountSelection?editDraft=true&orderId=${order.myCaseRef}`;
            } else if (
                order.orderType === 'ZLB' ||
                order.currentOrderType === 'ZLB'
            ) {
                redirectionLink = `view/content/usageQuickOrder?orderId=&orderType=&cartCode=${order.cartId}&entryTab=`;
            }
            break;
        case 'CTA_007': //No usage to report
            redirectionLink = `view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&popupRequired=cancelsurgery&sstRef=${order.myCaseRef}`;
            break;
        case 'CTA_009': // request Invoice
            redirectionLink = `view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&popupRequired=requestinvoice&sstRef=${order.myCaseRef}&sapPartnerId=${order.accountNumber}`;
            break;
        case 'CTA_012': // Report Usage
            redirectionLink = `view/content/usageQuickOrder?orderType=ZLC&cartCode=&entryTab=&orderId=${order.myCaseRef}`;
            break;
        case 'CTA_013': //Report payment
            redirectionLink = `view/content/usagePayment?orderId=${order.myCaseRef}&orderType=ZLB&cartCode=&entryPage=usagePayment`;
            break;
        case 'CTA_014': // Billing Summary
            redirectionLink = `view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&sstRef=${order.myCaseRef}&popupRequired=billingsummary`;
            break;
        case 'CTA_015': // Shipping/Tracking
            redirectionLink = `view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&sstRef=${order.myCaseRef}&popupRequired=shippingdetails`;
            break;
        case 'CTA_017': // ASSIGN CREDIT || ASSIGN Territory
            redirectionLink = `view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&popupRequired=assignterritory&sstRef=${order.myCaseRef}`;
            break;
        case 'CTA_018': // View Usage Reports
            redirectionLink = `view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&sstRef=${order.myCaseRef}`;
            break;
        case 'CTA_019': // mazorNavCode
            redirectionLink = `view/SpineOrderHistoryComponentController?requestOrViewMazorNAVCode=true&&sstRef=${order.myCaseRef}`;
            break;
        case 'CTA_020': // Transfer
            redirectionLink = `view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&popupRequired=transfersurgery&sstRef=${order.myCaseRef}`;
            break;
        case 'CTA_022': //Report procedure data
            redirectionLink = `view/content/equityProcedure?sstRef=${order.myCaseRef}`;
            break;
        case 'CTA_011': //View Adjustments
            redirectionLink = `view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&sstRef=${order.myCaseRef}&popupRequired=viewadjustments`;
            break;
        case 'ExportPdf': //hardcoded export pdf
            redirectionLink = `view/SpineOrderHistoryComponentController?exportToPdf=true&order=true&orderId=${order.myCaseRef}&timeZoneOffset=${timeZoneOffset}&timeZoneOffsetAbbr=${timeZoneAbbr}`;
            break;
        default:
            break;
    }

    return isImpersonationSessionActive()
        ? `${getWcmsHostName()}/${redirectionLink}&${getImpersonationLink()}`
        : `${getWcmsHostName()}/${redirectionLink}`;
};

export const ordersWCMSLinks = (entity) => {
    let orderRedirectionLink = '';
    switch (entity) {
        case 'orderEquity':
            orderRedirectionLink =
                'view/content/spineAccountSelection?newEquityOrder=true';
            break;
        case 'orderConsignmentBilling':
            orderRedirectionLink =
                'view/content/consignBillingAccountSelection?consOrderType=billing';
            break;
        case 'orderConsignmentReturn':
            orderRedirectionLink =
                'view/content/consignPickupAccountSelection?consOrderType=pickup';
            break;
        case 'ZOR':
            orderRedirectionLink =
                'view/content/spineAccountSelection?newEquityOrder=true';
            break;
        case 'ZKA':
            orderRedirectionLink =
                'view/content/consignPickupAccountSelection?consOrderType=pickup';
            break;
        case 'KE':
            orderRedirectionLink =
                'view/content/consignBillingAccountSelection?consOrderType=billing';
            break;
        case 'KB':
            orderRedirectionLink =
                'view/content/consignBillingAccountSelection?consOrderType=billing';
            break;
        case 'sets':
            orderRedirectionLink = 'view/content/InventoryListpage';
            break;
        case 'items':
            orderRedirectionLink =
                'view/content/InventoryListpage?getItemsInventory=true';
            break;
        case 'returned_sets':
            orderRedirectionLink =
                'view/content/InventoryListpage?getReturnSet=true&currentAccount=DEFAULT&districtSet=true';
            break;
        case 'consigned':
            orderRedirectionLink =
                'view/content/InventoryListpage?getConsignedInventory=true';
            break;
    }
    const isParameter = orderRedirectionLink.includes('?');

    return isImpersonationSessionActive()
        ? `${getWcmsHostName()}/${orderRedirectionLink}${
              isParameter ? '&' : '?'
          }${getImpersonationLink()}`
        : `${getWcmsHostName()}/${orderRedirectionLink}`;
};

// This below URL is for "Assign Territory". couldn't find any implementation above so adding it below.
// Testing is pending because SAML is on and unable to redirect.
// https://test2.sst.medtronic.com/view/content/spineOrderHistoryView?clearonsrch=true&isNavigatedUrl=true&popupRequired=assignterritory&sstRef=<MyCaseRef#>
